import { render, staticRenderFns } from "./ApproveInvoiceButton.vue?vue&type=template&id=72feefde&scoped=true&"
import script from "./ApproveInvoiceButton.vue?vue&type=script&lang=js&"
export * from "./ApproveInvoiceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72feefde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72feefde')) {
      api.createRecord('72feefde', component.options)
    } else {
      api.reload('72feefde', component.options)
    }
    module.hot.accept("./ApproveInvoiceButton.vue?vue&type=template&id=72feefde&scoped=true&", function () {
      api.rerender('72feefde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMemberInvoices/buttons/ApproveInvoiceButton.vue"
export default component.exports